import { z } from "zod";

export const healthResponseSchema = z.object({
  status: z.literal("ok"),
  service: z.string(),
  version: z.string(),
  uptimeSeconds: z.number().nonnegative(),
});
export type HealthResponse = z.infer<typeof healthResponseSchema>;

/** Which optional parts of the product this deployment offers; public, for the web client. */
export const featuresSchema = z.object({
  domainSales: z.boolean(),
  ai: z.boolean(),
  /** New workspaces can be created by anyone (off before launch; an allowlist still may). */
  signup: z.boolean(),
});
export type Features = z.infer<typeof featuresSchema>;
